import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
    allTournamentList,
    fetchTournamentList,
    deleteTournamentList
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddItem from './component/addform';
import UpdateItems from './component/editform';

class tournamentlist extends Component {
   
   constructor(props) {
      
      super(props);
      this.confirmationDialog = React.createRef();
         this.state = {
            viewdiv:true,
            adddiv:false,
            editdiv:false,
            club:'', 
            seldate:'',    
            name:'',
            country:'',
            eid:'',            
         
         };    

         
         this.onBackSection = this.onBackSection.bind(this);
         this.deleteForm = this.deleteForm.bind(this);
   } 

    UNSAFE_componentWillMount() {
	   this.props.allTournamentList();
	}


    onAddSession() {
		this.setState({ 
         viewdiv:false,
         editdiv:false,
         adddiv:true,
      });
    } 
      
    onBackSection() {
		this.setState({ 
         adddiv:false,
         viewdiv:true,
         editdiv:false,

       });
	}  


    editAssessment(gid){
        this.props.fetchTournamentList(gid).then((data) => {   
            var resdata=data.data;
            this.setState({ 
                club:resdata[0].gtl_course, 
                seldate:resdata[0].gtl_date,     
                name:resdata[0].gtl_name, 
                country:resdata[0].gtl_country, 
                eid:resdata[0].gtlID,            
              });


            this.setState({ 
                viewdiv:false,               
                adddiv:false,
                editdiv:true,
       
              });

        });
    }

    deleteForm(data){
      this.data = data;
      this.confirmationDialog.current.openDialog();
    }

    deleteDataPermanent(popupResponse){
      
        if (popupResponse) {
            this.props.deleteTournamentList(this.data);
            this.data = ""
        }
    }

    render() {
       const { match, tournamentalllist, loading } = this.props;
       const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
        };

        const columns = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "cdate", label: "DATE" },
            { name: "clubname", label: "COURSE" },
            { name: "country", label: "COUNTRY" },
            { name: "action", label: "ACTION" },
            { name: "action1", label: "ACTION1" },
          
        ];
        const tabledata=tournamentalllist.map((assmntval,idx) => {     
                     const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval.gtlID)}><EditOutlinedIcon/></IconButton>;
                     const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval.gtlID)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
                
                return {
                no:idx+1,
                name: assmntval.gtl_name,
                cdate: assmntval.cdate,
                clubname:assmntval.ccb_clubName,
                country:assmntval.gtl_country,
                action: ebtn,
                action1:dbtn,
                
                }
        });

 

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>Tournament List | {AppConfig.appTitle}</title>
                <meta name="description" content="Golf" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.tournamentlist" />} match={match} />
             
               {this.state.viewdiv && 
                  <div className="col-sm-12 col-md-12">
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable
                              title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Tournament</Button></div>}
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>
               }
               {this.state.adddiv && 
                  <AddItem onClick={this.onBackSection} />                
               }

               {this.state.editdiv && 
                <UpdateItems onClick={this.onBackSection} data={this.state}/>   
               }

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'tournament'}
            />
                  
          </div>
       )
    }
 }

const mapStateToProps = ({ tournamentlist }) => {
	const { tournamentalllist, loading } = tournamentlist;
	return { tournamentalllist, loading };
}

export default connect(mapStateToProps, {
    allTournamentList,
    fetchTournamentList,
    deleteTournamentList
})(tournamentlist); 